import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-edital-procedimento',
  templateUrl: './edital-procedimento.component.html',
  styleUrls: ['./edital-procedimento.component.scss']
})
export class EditalProcedimentoComponent implements OnInit {
  links01_2019: Array<any> = [
    {
      name:"10721-2019 Resolução Comissão Avaliação Chamamento Pub Geral 2019",
      value:"assets/Documents/resolucao.pdf"
    },
    {
      name:"Edital - Procedimento manifestação de interesse",
      value:"assets/Documents/edital.pdf"
    },
    {
      name:"Substituição de servidor designado na Comissão de Avaliação de Manifestação de Interesse n 01-2019 - Doação de bens e direitos ou serviços, sem encargos",
      value:"assets/Documents/substituicao.pdf"
    },
    {
      name:"Resolução SSP CAMI",
      value:"assets/Documents/resolucaoCAMI.pdf"
    },
    {
      name:"Resolução SSP 56",
      value:"assets/Documents/Res SSP 56.pdf"
    }
  ];

  links02_2020: Array<any> = [
    {
      name: "Publicação DOE abertura",
      value: "assets/Documents/pubDOEabertura_02.2020.pdf"
    },
    {
      name: "Edital - Procedimento manifestação de interesse 02_2020",
      value: "assets/Documents/editalProcInteresse_02.2020.pdf"
    }
  ];

  links01_2023: Array<any> = [
    {
      name: "Procedimento de Manifestação de Interesse nº 01-2023",
      value: "assets/Documents/PMI 01_2023.pdf"
    }
  ];

  constructor() { }

  ngOnInit() {
  }

  downloadFiles(){
    var link = document.createElement('a');
    link.style.display = 'none';
  
    document.body.appendChild(link);
  
    for (var i = 0; i < this.links01_2019.length; i++) {
      link.setAttribute('download', this.links01_2019[i].name);
      link.setAttribute('href', this.links01_2019[i].value);
      link.click();
    }  
    document.body.removeChild(link);
  }

  downloadFiles2020() {
    var link = document.createElement('a');
    link.style.display = 'none';
    document.body.appendChild(link);
    
    for (var i = 0; i < this.links02_2020.length; i++) {
      link.setAttribute('download', this.links02_2020[i].name);
      link.setAttribute('href', this.links02_2020[i].value);
      link.click();
    }  
    document.body.removeChild(link);
  }

  dowloadFiles2023_1() {    
    var link = document.createElement('a');
    link.style.display = 'none';
    document.body.appendChild(link);
    
    for (var i = 0; i < this.links01_2023.length; i++) {
      link.setAttribute('download', this.links01_2023[i].name);
      link.setAttribute('href', this.links01_2023[i].value);
      link.click();
    }  
    document.body.removeChild(link);
  }
}
